import { MicDeviceType } from "@/common/enums/enums";
import type {
  GetMobileDevicesRequestParameters,
  MobileDevices,
} from "@/common/types/mobileDevices";
import type { MicDevice } from "@/hooks/useAudioInputDevices";
import { getMobileDevices } from "@/services/mobileDevices";
import { create } from "zustand";

export interface MobileDevicesState {
  devices: MobileDevices[];
  loading: boolean;
  error: boolean;
  getMobileDevices: () => MicDevice[];
  fetch: (parameters: GetMobileDevicesRequestParameters) => Promise<void>;
}

export const useMobileDevicesStore = create<MobileDevicesState>()(
  (set, get) => ({
    devices: [],
    loading: false,
    error: false,

    getMobileDevices: (): MicDevice[] =>
      get().devices.map((d) => ({
        label: d.deviceName,
        value: d.id,
        default: false,
        type: MicDeviceType.MOBILE,
      })),

    fetch: async (
      parameters: GetMobileDevicesRequestParameters
    ): Promise<void> => {
      set({ loading: true, error: false });
      try {
        const devices = await getMobileDevices(parameters);
        set({ devices, loading: false });
      } catch {
        set({ devices: [], loading: false, error: true });
      }
    },
  })
);
